var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.356445,
    width: 18,
    height: 18,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3828_14479",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3828_14479",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAABmElEQVR4nO3cvUoDQRSG4dXCn8K7sLLcacTGS7NMI4J2AcEzbUqL4BXZCSKK5Seb1RQWkkTmzMzO+8B0gZx5GZbNJqTrAAAAAAAAAAAAABe6PT2UhWvF/kUW3hXDXIvzY593byly7JeKQb/WPPdsLUSWYv+We74GIq/Wa+4ZW4g8nOib3HO2EHk5vC73rNXS4uxAFh7/jGzhSQ+XR7lnrRaRHRDZAZEdENkBkR0Q2QGRHRDZAZEdENkBkR0Q2QGRHRDZAZEdENkBkR0Q2UH1kXXV7UvdXlcw1fxFqu4vTmTBFPtPxfAh6+9KHFQ1Rx6MkcseWNVHHi4X40kudnDVHnkdevy1ZJEb0BQi/1hdkwvciKYUudQNqcCZJndvqoJmmewGVcAMLnJuVK1EzrlhtRY5x8bVamTPAGo9skcIETl9EBE5fRgROX0gEXkz/wklIm9nl2Ai8m62CSciOz1hixN8Cudto9MaG/8wkj22ETl9bCNy+pNtRE4f24icPrYROdWfP81k4fl7zbiFAwAAAAAAAAAAQLf2BWbwBMTtn0a2AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.84f7421e452c68f61ee53fbb5829199d.svg";
export { ForwardRef as ReactComponent };